import React, { useState, useEffect } from "react";
import Button from "@src/components/UIElements/Button";
import AddressFields from "./components/AddressFields";
import { useSelector, useDispatch } from "react-redux";
import CONSTANTS from "./store/constants";
import {
  checkIsPincodeServicable,
  sendAddressDataAction,
} from "./store/actions";
import { useRouter } from "@src/lib/router";

import { t } from "i18next";
import { validateCity, validateEmail } from "../../utils";

function PhysicalAddress({ isPhysicalDeliveryEnabled }) {
  // ROUTER
  const router = useRouter();
  // SELECTORS
  const stateList = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.states
  );
  const pincodeErrorMsg = useSelector(
    (state) => state?.physicalShipmentReducer?.picodeErrorMessage
  );
  const bundles = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.bundles
  );
  // FORM STATE
  const [name, setName] = useState();
  const [address1, setAddress1] = useState();
  const [address2, setAddress2] = useState();
  const [landmark, setLandmark] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [pinCode, setPincode] = useState();
  const [mobile, setMobileNumber] = useState();
  const [alternateNumber, setAlternateNumber] = useState();
  const [email, setEmail] = useState();
  const [isDefault, setIsDefault] = useState(true);
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [disableButton, setDisableButton] = useState(true);
  const cityRegex = /[^a-zA-Z0-9 ]/;
  const mobileRegex=  /^[123456789]\d{9}$/;

  // FORM FIELDS
  let formFields = [
    {
      label: t("components.PhysicalAddress.index.name", "Full Name*"),
      placeholder: t(
        "components.PhysicalAddress.index.namePlaceholder",
        "e.g. Harsh"
      ),
      value: name,
      setValue: setName,
      errorMessage: t(
        "components.PhysicalAddress.index.nameError",
        "please add your Name (min. 3 characters)"
      ),
      isMandatory: 1,
      type: "text",
      // maxLength: "",
      length: 3,
      customClass: "Shipment__Modal__Body__Input--Field--Name",
    },
    {
      label: t("components.PhysicalAddress.index.addressOne", "Full Address*"),
      placeholder: t(
        "components.PhysicalAddress.index.addressOnePlaceholder",
        "e.g. Hno. 120"
      ),
      value: address1,
      setValue: setAddress1,
      errorMessage: t(
        "components.PhysicalAddress.index.addressOneNewError",
        "Please add your Full Address(min. 3 characters and max. 190 characters)"
      ),
      isMandatory: 1,
      type: "text",
      // maxLength: "",
      length: 3,
      customClass: "Shipment__Modal__Body__Input--Field--AddressOne",
      errorCondition: address1?.length < 3 || address1?.length > 190,
    },
    {
      label: t("components.PhysicalAddress.index.city", "City/District*"),
      placeholder: t(
        "components.PhysicalAddress.index.cityPlaceholder",
        "e.g. Delhi"
      ),
      value: city,
      setValue: setCity,
      errorMessage:
        (cityRegex.test(city) &&
          t(
            "components.PhysicalAddress.index.Specialcharacters",
            "Special characters are not allowed"
          )) ||
        t(
          "components.PhysicalAddress.index.cityNewError",
          "please enter your City here (min. 3 characters and max. 30 characters)"
        ),
      onBlur: () => values?.city && setCityError(!validateCity(values?.city)),
      isMandatory: 1,
      type: "text",
      maxLength: 30,
      length: 3,
      customClass: "Shipment__Modal__Body__Input--Field--City",
      errorCondition: cityRegex.test(city),
    },
    {
      label: t("components.PhysicalAddress.index.state", "State*"),
      placeholder: t(
        "components.PhysicalAddress.index.statePlaceholder",
        "Select a state"
      ),
      value: state,
      setValue: setState,
      errorMessage: t(
        "components.PhysicalAddress.index.stateError",
        "please select your State here"
      ),
      isMandatory: 1,
      type: "text",
      // maxLength: "",
      // length: "",
      customClass: "Shipment__Modal__Body__Input--Field--State",
      list: stateList,
    },
    {
      label: t("components.PhysicalAddress.index.pincode", "Pincode*"),
      placeholder: t(
        "components.PhysicalAddress.index.pincodePlaceholder",
        "e.g. 110011"
      ),
      value: pinCode,
      setValue: setPincode,
      errorMessage: t(
        "components.PhysicalAddress.index.pincodeError",
        "please enter a valid pin code here"
      ),
      isMandatory: 1,
      type: "number",
      maxLength: 6,
      length: 6,
      customClass: "Shipment__Modal__Body__Input--Field--Pin",
    },
    {
      label: t("components.PhysicalAddress.index.mobile", "Delivery Mobile Number*"),
      placeholder: t(
        "components.PhysicalAddress.index.mobilePlaceholder",
        "e.g. 8126196327"
      ),
      value: mobile,
      setValue: setMobileNumber,
      isMandatory: 1,
      type: "number",
      maxLength: 10,
      length: 10,
      customClass: "Shipment__Modal__Body__Input--Field--Mobile",
      errorCondition: !mobileRegex.test(mobile),
      errorMessage: mobile &&
        (!mobileRegex.test(mobile) &&
          t(
          "components.PhysicalAddress.index.mobileError",
          "please enter valid mobile number here"
        ))
    },
    {
      label: t("components.PhysicalAddress.index.alternateNumber", "Alternate Mobile Number (Optional)"),
      placeholder: t(
        "components.PhysicalAddress.index.alternateNumberPlaceholder",
        "e.g. 8126196327"
      ),
      value: alternateNumber,
      setValue: setAlternateNumber,
      isMandatory: 0,
      type: "number",
      maxLength: 10,
      length: 10,
      customClass: "Shipment__Modal__Body__Input--Field--AlternateNumber",
      errorCondition: !mobileRegex.test(alternateNumber),
      errorMessage: alternateNumber &&
        (!mobileRegex.test(alternateNumber) &&
          t(
          "components.PhysicalAddress.index.alternateNumberError",
          "please enter valid mobile number here"
        ))
    },
  ];

  const [formData, setFormData] = useState(formFields);

  // DISPATCH
  const dispatch = useDispatch();

  let payload = {
    name,
    address1,
    address2,
    landmark,
    city,
    state,
    pinCode,
    mobile,
    isDefault,
    email,
    courseId: router?.query?.courseId,
    alternateNumber
  };

  const sendAddressData = (actionType, payload) => {
    dispatch(sendAddressDataAction(actionType, payload));
  };

  const saveAddress = () => {
    sendAddressData(CONSTANTS.SHIPMENT_ADDRESSDATA_POST, payload);
  };

  const updateAddress = () => {
    sendAddressData(CONSTANTS.SHIPMENT_EDITADDRESSDATA_PUT, {
      ...payload,
      addressId: activeAddress?.id,
    });
  };

  const handleClick = () => {
    isEditMode ? updateAddress() : saveAddress();
  };

  // SELECTORS
  const isEditMode = useSelector(
    (state) => state?.physicalShipmentReducer?.isEditMode
  );

  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );

  // EFFECTS
  useEffect(() => {
    if (isEditMode && activeAddress) {
      setAddress1(activeAddress?.address1);
      setAddress2(activeAddress?.address2);
      setName(activeAddress?.name);
      setCity(activeAddress?.city);
      setState(activeAddress?.state);
      setLandmark(activeAddress?.landmark);
      setPincode(activeAddress?.pinCode);
      setMobileNumber(activeAddress?.mobile);
      setEmail(activeAddress?.email);
      setIsDefault(1);
      setAlternateNumber(activeAddress?.alternateNumber);
    }
  }, [isEditMode, activeAddress]);

  useEffect(() => {
    if (
      name?.length >= 3 &&
      address1?.length >= 3 &&
      address1?.length <= 190 &&
      city?.length >= 3 &&
      city?.length <= 30 &&
      state &&
      !cityRegex.test(city) &&
      pinCode?.toString()?.length === 6 &&
      mobile?.length >= 8 && mobileRegex.test(mobile) && (!alternateNumber || (alternateNumber && mobileRegex.test(alternateNumber)))
    ) {
      if (isPhysicalDeliveryEnabled || bundles?.length > 0) {
        const isValid = validateEmail(email);
        setDisableButton(!isValid);
      } else {
        setDisableButton(false);
      }
    } else {
      setDisableButton(true);
    }
  }, [name, address1, city, state, pinCode, mobile, email, alternateNumber]);

  //alert(formFields[4].label);
  if (
    (isPhysicalDeliveryEnabled || bundles?.length > 0) &&
    formFields[4].label ===
      t("components.PhysicalAddress.index.pincode", "Pincode*")
  ) {
    formFields.splice(4, 1);
    formFields.unshift({
      label: t("components.PhysicalAddress.index.pincode", "Pincode*"),
      placeholder: t(
        "components.PhysicalAddress.index.pincodePlaceholder",
        "e.g. 110011"
      ),
      value: pinCode,
      setValue: setPincode,
      errorMessage: t(
        "components.PhysicalAddress.index.pincodeError",
        "please enter a valid pin code here"
      ),
      isMandatory: 1,
      type: "number",
      maxLength: 6,
      length: 6,
      customClass: "Shipment__Modal__Body__Input--Field--Pin",
    });
    formFields.push({
      label: "Email*",
      placeholder: t("email", "e.g. joe@gmail.com"),
      value: email,
      setValue: setEmail,
      errorMessage: "please enter a valid email id",
      isMandatory: 1,
      type: "email",
      maxLength: 30,
      length: 4,
      customClass: "Shipment__Modal__Body__Input--Field--Email",
      errorCondition: !emailRegex.test(email),
    });
  }
  let isValid;
  const checkPincode = new RegExp(/^[1-9][0-9]{5}$/);

  useEffect(() => {
    const isValid = checkPincode.test(pinCode) ? true : false;
    if (pinCode && isValid && isPhysicalDeliveryEnabled) {
      dispatch(checkIsPincodeServicable(pinCode));
    }
  }, [pinCode]);

  return (
    <div className="AddressForm">
      <div className="AddressForm__Fields">
        {formFields?.map((item, i) => (
          <AddressFields {...item} key={i} />
        ))}
        <div className="AddressForm__Fields--Note">
          *{" "}
          {t(
            "components.PhysicalAddress.index.note",
            "Your address can’t be changed once the order is placed"
          )}
        </div>
      </div>
      <div className="AddressForm__Save">
        <Button
          onClick={handleClick}
          disabled={
            disableButton || (isPhysicalDeliveryEnabled && pincodeErrorMsg)
          }
        >
          {isEditMode
            ? t("components.PhysicalAddress.index.update", "Update Address")
            : t("components.PhysicalAddress.index.save", "Save Address")}
        </Button>
      </div>
    </div>
  );
}

export default PhysicalAddress;
